import React from 'react';
function BodyFatTable({ result }) {
    return (
        <div>
            <div>
            <table >
                    <thead>
                        <tr>
                            <th >Status</th>
                            <th >Percentage</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Fat Percentage:</td>
                            <td>{result.bodyFatPercentage} %</td>
                        </tr>
                        <tr>
                            <td>Fat Mass:</td>
                            <td>{result.fatMass} kg</td>
                        </tr>
                        <tr>
                            <td>Lean Body Mass:</td>
                            <td>{result.leanMass} kg</td>
                        </tr>
                        <tr>
                            <td>Body Fat Category:</td>
                            <td>{result.bodyFatCategory}</td>
                        </tr>
                        {result.idealBodyFatPercentage !== 0 && (
                            <>
                                <tr>
                                    <td>Ideal Body Fat Percentage:</td>
                                    <td>{result.idealBodyFatPercentage} %</td>
                                </tr>
                                <tr>
                                    <td>Fat Needed to Reach Ideal:</td>
                                    <td>{result.bodyFatToLose} kg</td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
            </div>
            <div>
                <br />
                <hr />
                <div>
                <table >
                        <thead>
                            <tr>
                                <th >Category</th>
                                <th >Male</th>
                                <th >Female</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className={result.bodyFatCategory === 'Essential Fat' ? 'highlightedOk' : ''}>
                                <td>Essential Fat</td>
                                <td>2-5%</td>
                                <td>10-13%</td>
                            </tr>
                            <tr className={result.bodyFatCategory === 'Athletes' ? 'highlightedOk' : ''}>
                                <td>Athletes</td>
                                <td>6-13%</td>
                                <td>14-20%</td>
                            </tr>
                            <tr className={result.bodyFatCategory === 'Fitness' ? 'highlightedOk' : ''}>
                                <td>Fitness</td>
                                <td>14-17%</td>
                                <td>21-24%</td>
                            </tr>
                            <tr className={result.bodyFatCategory === 'Acceptable' ? 'highlightedOk' : ''}>
                                <td>Acceptable</td>
                                <td>18-24%</td>
                                <td>25-31%</td>
                            </tr>
                            <tr className={result.bodyFatCategory === 'Obese' ? 'highlightedDanger' : ''}>
                                <td>Obese</td>
                                <td>+ 25%</td>
                                <td>+ 32%</td>
                            </tr>
                            <tr>
                                <td colSpan="3">
                                    <b>Source:</b>{' '}
                                    <a href="https://www.acefitness.org/resources/everyone/tools-calculators/percent-body-fat-calculator/">
                                        American Council on Exercise
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="3">
                                    <b>Last Reviewed:</b> 16/06/2023
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <br />
            </div>
        </div>
    );
}
export default BodyFatTable;
